// @mui
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
//
import Header from './Header';
import useOffSetTop from 'src/hooks/useOffSetTop';
import { HEADER } from 'src/config-global';

// ----------------------------------------------------------------------

type Props = {
  children?: React.ReactNode;
};

export default function CompactLayout({ children }: Props) {
  const isOffset = useOffSetTop(HEADER.H_MAIN_DESKTOP);

  return (
    <>
      <Header isOffset={isOffset} />

      <Container component="main">
        <Stack
          sx={{
            py: '2vh',
            m: 'auto',
            maxWidth: 400,
            minHeight: '90vh',
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          {children}
        </Stack>
      </Container>
    </>
  );
}
